import "../components/print.css"
import React, {useEffect, useState} from "react";
import general from "../../../../utils/general";
import ResumePage from "../components/resume-page";
import ReportSection from "../components/report-section";
import {statusList} from "../../../software-attendances/resources/statusList";

const BASENAME = process.env.PUBLIC_URL;

const Badge = ({ type }) => {
    let bgColor, borderColor, textColor, icon;
    const normalizedType = type.toLowerCase().trim();
    if (normalizedType.includes('novidade')) {
        bgColor = "bg-[#FFF1B9]";
        borderColor = "border-[#CBA052]";
        textColor = "text-[#998329]";
        icon = <img src={`${BASENAME}/img/star.svg`} alt="Icone"/>;
    }
    else if (normalizedType.includes('melhoria')) {
        bgColor = "bg-[#15937A]";
        borderColor = "border-[#0D8E69]";
        textColor = "text-white";
        icon = <img src={`${BASENAME}/img/arrow.svg`} alt="Icone"/>;
    }
    else if (normalizedType.includes('correção') || normalizedType.includes('correcao')) {
        bgColor = "bg-[#5EB5FF]";
        borderColor = "border-[#2D88FF]";
        textColor = "text-[#0F538E]";
        icon = <img src={`${BASENAME}/img/check.svg`} alt="Icone"/>;
    }
    else {
        bgColor = "bg-gray-100";
        borderColor = "border-gray-300";
        textColor = "text-gray-600";
        icon = null;
    }

    return (
        <span className={`inline-flex items-center gap-1.5 ${bgColor} border ${borderColor} ${textColor} px-2 py-[2px] rounded-[3px] text-[14px] font-bold shadow-sm tracking-wider whitespace-nowrap`}>
            {icon}
            {type}
        </span>
    );
}

const parseVersionsHtml = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString || '', 'text/html');
    const elements = Array.from(doc.body.childNodes);

    const sections = [];
    let currentSection = null;
    let currentCard = null;

    const ensureCard = () => {
        if (!currentCard) {
            currentCard = { title: '', items: [] };
            if (!currentSection) {
                currentSection = { title: '', cards: [] };
                sections.push(currentSection);
            }
            currentSection.cards.push(currentCard);
        }
    };

    const processLine = (itemStr) => {
        let badge = '';
        let subtitle = '';
        let text = '';

        const badgeRegex = /<(?:strong|b)>\s*<(?:em|i)>\s*(.*?)\s*<\/(?:em|i)>\s*<\/(?:strong|b)>/i;
        const badgeMatch = itemStr.match(badgeRegex);

        if (badgeMatch) {
            let rawBadge = badgeMatch[1].replace(/&nbsp;/g, ' ').trim();
            rawBadge = rawBadge.replace(/\s*-\s*$/, '');
            badge = rawBadge;

            let remainingStr = itemStr.replace(badgeMatch[0], '').trim();
            remainingStr = remainingStr.replace(/^(?:&nbsp;|\s|-)+/, '').trim();

            const subtitleMatch = remainingStr.match(/<(?:strong|b)>\s*<(?:em|i)>\s*(.*?)\s*<\/(?:em|i)>\s*<\/(?:strong|b)>/i);
            if (subtitleMatch) {
                subtitle = subtitleMatch[1].replace(/&nbsp;/g, ' ').trim();
                remainingStr = remainingStr.replace(subtitleMatch[0], '').trim();
                remainingStr = remainingStr.replace(/^(?:&nbsp;|\s|-)+/, '').trim();
            }
            text = remainingStr;
        } else {
            text = itemStr;
        }

        text = text.replace(/^(?:&nbsp;|\s)+/, '').trim();

        if (text === '<u></u>' || text === '<strong></strong>') return;

        if (text || badge || subtitle) {
            ensureCard();
            currentCard.items.push({ badge, subtitle, text });
        }
    };

    elements.forEach(el => {
        if (el.nodeType !== 1) return;
        const nodeName = el.nodeName;

        if (nodeName === 'H1') {
            currentSection = { title: el.textContent.trim(), cards: [] };
            sections.push(currentSection);
            currentCard = null;
        } else if (nodeName === 'H2') {
            currentCard = { title: el.textContent.trim(), items: [] };
            if (!currentSection) {
                currentSection = { title: '', cards: [] };
                sections.push(currentSection);
            }
            currentSection.cards.push(currentCard);
        } else if (nodeName === 'P' || nodeName === 'DIV') {
            const itemStrings = el.innerHTML.split(/<br\s*\/?>/i).map(s => s.trim()).filter(s => s);
            itemStrings.forEach(processLine);
        } else if (nodeName === 'UL') {
            const listHtml = el.outerHTML.trim();
            if (listHtml) {
                ensureCard();
                currentCard.items.push({ badge: '', subtitle: '', text: listHtml, isList: true });
            }
        }
    });

    return sections;
};

const parseJsonArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

const normalizePrintData = (rawValue) => {
    if (!rawValue) return null;

    try {
        const parsed = JSON.parse(rawValue);

        return {
            hardwareAttendances: parsed.hardwareAttendances ?? [],
            softwareAttendances: parsed.softwareAttendances ?? [],
            trainings: parsed.trainings ?? [],
            versions: parsed.versions ?? [],
            project: parsed.project ?? "",
            afterSales: parsed.afterSales ?? [],
            period: parsed.period ?? "",
        };
    } catch {
        return null;
    }
};

const PrintServiceProvided = () => {
    const [softwareSolvedEnded, setSoftwareSolvedEnded] = useState([]);
    const [softwareMultiway, setSoftwareMultiway] = useState([]);
    const [softwareClient, setSoftwareClient] = useState([]);
    const [trainingsData, setTrainingsData] = useState([]);
    const [versionsData, setVersionsData] = useState([]);
    const [hardwareData, setHardwareData] = useState([]);
    const [afterSales, setAfterSales] = useState([])
    const [countData, setCountData] = useState(null)
    const [project, setProject] = useState("")
    const [period, setPeriod] = useState("")

    useEffect(() => {
        const localData = normalizePrintData(localStorage.getItem('services-provided'));
        if (!localData) {
            return;
        }

        const {
            hardwareAttendances,
            softwareAttendances,
            trainings,
            versions,
            project,
            afterSales,
            period
        } = localData;

        let solvedEnded = []
        let multiway = []
        let cliente = []

        if (softwareAttendances.length > 0) {
            softwareAttendances.forEach((soft) => {
                if (soft.status === "ENCERRADO" || soft.status === "SOLUCIONADO"){
                    solvedEnded.push(soft)
                }

                if (soft.status === "ABERTO"){
                    multiway.push(soft)
                }

                if (soft.status === "CLIENTE"){
                    cliente.push(soft)
                }
            })
        }

        const normalizedAfterSales = afterSales.map((aft) => {
            const attendances = parseJsonArray(aft.attendances);
            const requesters = parseJsonArray(aft.requesters);

            return {
                ...aft,
                attendances: attendances.length > 0 ? attendances.map(attend => `${attend}`).join(", ") : aft.attendances,
                totalAttendances: attendances.length,
                requesters: requesters.length > 0 ? requesters.map(req => `${req}`).join(", ") : aft.requesters,
                totalRequesters: requesters.length,
                duration: aft.duration ? String(aft.duration).padStart(2, '0') + ":00" : "00:00",
            };
        });

        setSoftwareSolvedEnded(solvedEnded)
        setSoftwareMultiway(multiway)
        setSoftwareClient(cliente)
        setTrainingsData(trainings)
        setVersionsData(versions)
        setHardwareData(hardwareAttendances)
        setProject(project)
        setPeriod(period)
        setAfterSales(normalizedAfterSales)
        setCountData({
            solvedEnded: solvedEnded?.length,
            multiway: multiway?.length,
            cliente: cliente?.length,
            trainings: trainings?.length,
            versions: versions?.length,
            hardwareAttendances: hardwareAttendances?.length,
            afterSales: normalizedAfterSales?.length,
        })

    }, []);

    useEffect(() => {
        if (countData) {
            const timer = setTimeout(() => {
                window.print();
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [countData]);

    const DataItem = ({ id, labelId = "Atendimento Nº", date, status, requester, problem, observation }) => (
        <div className="text-[14px] whitespace-pre-wrap py-2 break-inside-auto">
            <p className="text-[#156DC4] font-bold text-[17px] mb-2 break-inside-avoid">{labelId} {id}</p>
            <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Abertura:</b> <span className="text-gray-700">{date}</span></p>
            <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Status:</b> <span className="text-gray-700">{status}</span></p>
            <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Solicitante:</b> <span className="text-gray-700">{requester}</span></p>
            <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Requisição:</b> <span className="text-gray-700">{problem}</span></p>
            <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Observação:</b> <span className="text-gray-700">{observation}</span></p>
        </div>
    );

    const filterSoftwareStatus = (statusToFilter) => {
        if (!statusToFilter) return "";

        const filtered = statusList.find(status =>
            status.value === statusToFilter.toUpperCase()
        )
        return filtered?.label ?? statusToFilter
    }

    const formatToTextTime = (timeStr) => {
        if (!timeStr) return "0 horas";

        const cleanStr = String(timeStr).trim();
        let hours = 0;
        let minutes = 0;

        if (cleanStr.includes('.')) {
            const match = cleanStr.match(/^(\d+\.\d+)/);
            if (match) {
                const decimalValue = parseFloat(match[1]);

                hours = Math.floor(decimalValue);

                minutes = Math.round((decimalValue - hours) * 60);
            }
        }
        else if (cleanStr.includes(':')) {
            const match = cleanStr.match(/^(\d+):(\d+)/);
            if (match) {
                hours = parseInt(match[1], 10);
                minutes = parseInt(match[2], 10);
            }
        }

        const labelHora = hours === 1 ? "hora" : "horas";
        const labelMinuto = minutes === 1 ? "minuto" : "minutos";

        if (hours > 0 && minutes > 0) {
            return `${hours} ${labelHora} e ${minutes} ${labelMinuto}`;
        } else if (hours > 0) {
            return `${hours} ${labelHora}`;
        } else if (minutes > 0) {
            return `${minutes} ${labelMinuto}`;
        } else {
            return "0 horas";
        }
    }

    const formatOpenTimeLabel = (dateValue, options = {}) => {
        const {
            format = "DD/MM/YYYY HH:mm",
            includeHours = true,
            includeMinutesForSameDay = true,
        } = options;

        if (!dateValue) return "";

        const openedAt = new Date(dateValue);
        if (Number.isNaN(openedAt.getTime())) {
            return general.formatDate(dateValue, format);
        }

        const formattedDate = general.formatDate(dateValue, format);
        const diffMs = Date.now() - openedAt.getTime();

        if (diffMs <= 0) {
            return formattedDate;
        }

        const totalMinutes = Math.floor(diffMs / (1000 * 60));
        const totalHours = Math.floor(diffMs / (1000 * 60 * 60));
        const totalDays = Math.floor(totalHours / 24);
        const totalMonths = Math.floor(totalDays / 30);
        const totalYears = Math.floor(totalMonths / 12);
        const parts = [];

        if (totalYears >= 1) {
            const months = totalMonths % 12;
            parts.push(`${totalYears} ${totalYears === 1 ? "ano" : "anos"}`);
            if (months > 0) {
                parts.push(`${months} ${months === 1 ? "mês" : "meses"}`);
            }
        } else if (totalMonths >= 1) {
            const weeks = Math.floor((totalDays % 30) / 7);
            parts.push(`${totalMonths} ${totalMonths === 1 ? "mês" : "meses"}`);
            if (weeks > 0) {
                parts.push(`${weeks} ${weeks === 1 ? "semana" : "semanas"}`);
            }
        } else if (totalDays >= 7) {
            const weeks = Math.floor(totalDays / 7);
            const days = totalDays % 7;
            parts.push(`${weeks} ${weeks === 1 ? "semana" : "semanas"}`);
            if (days > 0) {
                parts.push(`${days} ${days === 1 ? "dia" : "dias"}`);
            }
        } else if (totalDays >= 1) {
            parts.push(`${totalDays} ${totalDays === 1 ? "dia" : "dias"}`);
        } else if (includeHours && totalHours >= 1) {
            const hours = Math.max(totalHours, 0);
            parts.push(`${hours} ${hours === 1 ? "hora" : "horas"}`);
        } else if (includeMinutesForSameDay) {
            const minutes = Math.max(totalMinutes, 0);
            parts.push(`${minutes} ${minutes === 1 ? "minuto" : "minutos"}`);
        }

        if (parts.length === 0) {
            parts.push(includeHours ? "0 horas" : "0 dias");
        }

        return `${formattedDate} (Aberto há ${parts.join(" e ")})`;
    }

    return (
        <div className="print-container">
            <div className="fixed bottom-[55px] left-[60px] right-[60px] flex justify-between items-end z-40 print:fixed print:bottom-[55px] print:left-[60px] print:right-[60px] print:z-40 pointer-events-none">
                <p className="text-gray-400 text-sm mb-1">www.sentry.com.br</p>
                <img src={`${BASENAME}/img/sentry.svg`} alt="sentry logo"/>
            </div>

            <div className="fixed top-0 left-0 w-full h-[100vh] z-[-5] pointer-events-none">
                <img className="w-full h-full object-cover" src={`${BASENAME}/img/report_background.svg`} alt="" />
            </div>

            <div className="fixed top-[135px] bottom-[121px] left-[52px] right-[52px] border-[2px] border-gray-300 rounded-md z-[-1] pointer-events-none print:block hidden"></div>

            <div className="first-page flex flex-col justify-between min-h-[100vh] w-full p-[30px] break-after-page break-inside-avoid relative z-50 bg-white print:color-adjust-exact"
                style={{
                    backgroundImage: `url('${BASENAME}/img/report_cover.png')`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                }}
            >
            </div>

            <div>
                <ResumePage data={countData} project={project} period={period}/>
            </div>

            <div className="break-before-page">
                {
                    softwareSolvedEnded.length > 0 ? (
                        <ReportSection title="Atendimentos (Encerrados)" project={project} period={period}>
                            {softwareSolvedEnded.map((item, index) => (
                                <React.Fragment key={index}>
                                    { index >= 1 && <div className="w-full h-[0.2px] rounded-full bg-[#156DC4] my-2.5"/>}
                                    <DataItem
                                        id={item.id}
                                        date={general.formatDate(item.dt_initial)}
                                        status={filterSoftwareStatus(item.status)}
                                        requester={item.requester}
                                        problem={item.problem}
                                        observation={item.observation}
                                    />

                                </React.Fragment>
                            ))}
                        </ReportSection>
                    ) : (
                        <ReportSection title="Atendimentos (Encerrados e Solucionados)" project={project} period={period}>
                            <div className="block relative break-inside-auto text-[15px] italic text-gray-500 py-4">Sem atendimentos solucionados e encerrados durante o período.</div>
                            <div className={`w-full h-[0.2px] rounded-full bg-[#686868] my-1`}></div>
                        </ReportSection>
                    )}
            </div>

            <div className="break-before-page">
                {
                    softwareMultiway.length > 0 ?(
                        <ReportSection title="Atendimentos (Pendentes suporte)" project={project} period={period}>
                            {softwareMultiway.map((item, index) => (
                                <React.Fragment key={index}>
                                    { index >= 1 && <div className="w-full h-[0.2px] rounded-full bg-[#156DC4] my-2.5"/>}
                                    <DataItem
                                        id={item.id}
                                        date={formatOpenTimeLabel(item.dt_initial)}
                                        status={filterSoftwareStatus(item.status)}
                                        requester={item.requester}
                                        problem={item.problem}
                                        observation={item.observation}
                                    />

                                </React.Fragment>
                            ))}
                        </ReportSection>
                    ) : (
                        <ReportSection title="Atendimentos (Pendentes suporte)" project={project} period={period}>
                            <div className="block relative break-inside-auto text-[15px] italic text-gray-500 py-4">Sem atendimentos com pendências da Multiway durante o período.</div>
                            <div className={`w-full h-[0.2px] rounded-full bg-[#686868] my-1`}></div>
                        </ReportSection>
                    )}
            </div>

            <div className="break-before-page">
                {
                    softwareClient.length > 0 ?(
                        <ReportSection title="Atendimentos (Pendentes - Cliente)" project={project} period={period}>
                            {softwareClient.map((item, index) => (
                                <React.Fragment key={index}>

                                    { index >= 1 && <div className="w-full h-[0.2px] rounded-full bg-[#156DC4] my-2.5"/>}
                                    <DataItem
                                        id={item.id}
                                        date={formatOpenTimeLabel(item.dt_initial)}
                                        status={filterSoftwareStatus(item.status)}
                                        requester={item.requester}
                                        problem={item.problem}
                                        observation={item.observation}
                                    />

                                </React.Fragment>
                            ))}
                        </ReportSection>
                    ) : (
                        <ReportSection title="Atendimentos (Pendentes - Cliente)" project={project} period={period}>
                            <div className="block relative break-inside-auto text-[15px] italic text-gray-500 py-4">Sem atendimentos com pendências do cliente durante o período.</div>
                            <div className={`w-full h-[0.2px] rounded-full bg-[#686868] my-1`}></div>
                        </ReportSection>
                    )}
            </div>

            <>
                {
                    afterSales.length > 0 &&
                    <div className="break-before-page">
                        <ReportSection title="Atendimentos (Estratégicos)" project={project} period={period}>
                            {afterSales.map((item, index) => (
                                <React.Fragment key={index}>

                                    { index >= 1 && <div className="w-full h-[0.2px] rounded-full bg-[#156DC4] my-2.5"/>}
                                    <div className="block relative text-[14px] whitespace-pre-wrap py-2 break-inside-auto">
                                        <p className="text-[#156DC4] font-bold text-[17px] mb-2 break-inside-avoid">Atendimento Nº {item.id}</p>
                                        <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Data:</b> <span className="text-gray-700">{general.formatDate(item.date, "DD/MM/YYYY")}</span></p>
                                        <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Duração:</b> <span className="text-gray-700">{formatToTextTime(item.duration)}</span></p>
                                        <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Solicitantes:</b> <span className="text-gray-700">{item.requesters}</span></p>
                                        <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Atendentes:</b> <span className="text-gray-700">{item.attendances}</span></p>
                                        <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Descrição:</b> <span className="text-gray-700">{item.description}</span></p>
                                    </div>

                                </React.Fragment>
                            ))}
                        </ReportSection>
                    </div>
                }
            </>

            <div className="break-before-page">
                {
                    trainingsData.length > 0 ?(
                        <ReportSection title="Treinamentos" project={project} period={period}>
                            {trainingsData.map((item, index) => (
                                <React.Fragment key={index}>

                                    { index >= 1 && <div className="w-full h-[0.2px] rounded-full bg-[#156DC4] my-2.5"/>}
                                    <div className="block relative text-[14px] whitespace-pre-wrap py-2 break-inside-auto">
                                        {item.module && <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Módulo:</b> <span className="text-gray-700">{item.module}</span></p>}
                                        <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Data:</b> <span className="text-gray-700">{general.formatDate(item.date + " 00:00:00", "DD/MM/YYYY")}</span></p>
                                        <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Carga horária:</b> <span className="text-gray-700">{formatToTextTime(item.hours)}</span></p>
                                        <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Instrutor:</b> <span className="text-gray-700">{item.treinee}</span></p>
                                        <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Tipo:</b> <span className="text-gray-700">{item.session_type}</span></p>
                                        {item.session_type !== "Webinar" &&
                                            <>
                                                <p className="mb-1.5 break-inside-avoid"><b className="text-[#156DC4]">Participantes:</b> <span className="text-gray-700">{item.total_users ?? 0}</span></p>
                                                {item.user_names && (
                                                    <div className="mt-2 text-gray-700 break-inside-avoid">
                                                        <ul className="list-disc ml-6">
                                                            {item.user_names.split(', ').map((name, i) => (
                                                                <li key={i}>{name}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </>
                                        }
                                    </div>

                                </React.Fragment>
                            ))}
                        </ReportSection>
                    ) : (
                        <ReportSection title="Treinamentos" project={project} period={period}>
                            <div className="block relative break-inside-auto text-[15px] italic text-gray-500 py-4">Sem treinamentos durante o período.</div>
                            <div className={`w-full h-[0.2px] rounded-full bg-[#686868] my-1`}></div>
                        </ReportSection>
                    )}
            </div>

            {versionsData.map((versionItem, vIndex) => {
                const parsedSections = parseVersionsHtml(versionItem.content);

                return parsedSections.map((section, sIndex) => {

                    return (
                        <div key={`version-${vIndex}-${sIndex}`} className="break-before-page">
                            <ReportSection
                                title={`Versões (Versão ${versionItem.version})`}
                                project={project}
                                period={period}
                                showTitle={vIndex === 0 && sIndex === 0}
                            >
                                {section.cards.map((card, cIndex) => {

                                    const isNotaCard = card.title && card.title.toLowerCase().trim().includes('nota');

                                    const cardTextColor = isNotaCard ? 'text-[#686868] text-[20px]' : 'text-[#CBA052] text-[18px]';
                                    const cardBorderColor = isNotaCard ? 'bg-[#686868]' : 'bg-[#F2D091]';
                                    const [firstItem, ...remainingItems] = card.items;

                                    const renderVersionItem = (itemObj, iIndex) => {
                                        const isNotaBadge = itemObj.badge && itemObj.badge.toLowerCase().trim().includes('nota');
                                        const contentClassName = itemObj.isList
                                            ? "flex-1 min-w-0 break-words text-[15px] text-[#686868] leading-relaxed relative ml-4 after:absolute after:bottom-0 after:left-0 after:w-full after:h-[1px] after:bg-[#CCCCCC] after:rounded-full [&>p:last-child]:mb-0 [&_ul]:list-disc [&_ul]:pl-8 [&_ul]:mt-[-15px] [&_ul]:mb-1 [&_li]:mb-1 [&_p]:mb-0"
                                            : "flex-1 min-w-0 break-words text-[15px] text-[#686868] leading-relaxed relative after:absolute after:bottom-0 after:left-0 after:w-full after:h-[1px] after:bg-[#CCCCCC] after:rounded-full [&>p:last-child]:mb-0 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-2 [&_li]:mb-1 [&_p]:mb-0";

                                        return (
                                            <div key={`item-${iIndex}`} className="version-card-item flex items-start gap-4 py-3 ">

                                                {!isNotaBadge && (
                                                    <div className="w-[100px] shrink-0 pt-[2px] text-right flex justify-end">
                                                        {itemObj.badge && <Badge type={itemObj.badge} />}
                                                    </div>
                                                )}

                                                <div className={contentClassName}>
                                                    {itemObj.subtitle && <strong className="text-gray-800 mr-1">{itemObj.subtitle}</strong>}
                                                    <div dangerouslySetInnerHTML={{ __html: itemObj.text }} />
                                                </div>
                                            </div>
                                        );
                                    };

                                    return (
                                        <div key={`card-${cIndex}`} className="version-card mb-6 bg-transparent">

                                            <div className="version-card-start ">
                                                {section.title && cIndex === 0 && (
                                                    <div className="version-section-heading pt-5 pb-5">
                                                        <h2 className={`text-[#998329] text-[20px] tracking-wide font-bold`}>{section.title}</h2>
                                                        <div className="w-full h-[0.1px] bg-[#C7B15A] rounded-full mt-[0.25rem]"></div>
                                                    </div>
                                                )}

                                                {card.title && (
                                                    <div className="version-card-heading pt-2 pb-2">
                                                        <h2 className={`${cardTextColor} tracking-wide font-bold`}>{card.title}</h2>
                                                        <div className={`w-full h-[0.2px] rounded-full ${cardBorderColor} mt-[0.25rem]`}></div>
                                                    </div>
                                                )}

                                                {firstItem && renderVersionItem(firstItem, 0)}
                                            </div>

                                            <div className={`pb-4 ${!card.title ? 'pt-4' : ''}`}>
                                                {remainingItems.map((itemObj, iIndex) => renderVersionItem(itemObj, iIndex + 1))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </ReportSection>
                        </div>
                    );
                });
            })}

            {versionsData.length === 0 &&
                <div className="break-before-page">
                    <ReportSection title="Versões" project={project} period={period}>
                        <div className="block relative break-inside-auto text-[15px] italic text-gray-500 py-4">Sem atualizações de versão durante o período.</div>
                        <div className={`w-full h-[0.2px] rounded-full bg-[#686868] my-1`}></div>
                    </ReportSection>
                </div>
            }


            <div className="break-before-page">
                {
                    hardwareData.length > 0 ? (
                        <ReportSection title="Infraestrutura (Chamados)" project={project} period={period}>
                            {hardwareData.map((item, index) => (
                                <React.Fragment key={index}>

                                    { index >= 1 && <div className="w-full h-[0.2px] rounded-full bg-[#156DC4] my-2.5"/>}
                                    <DataItem
                                        id={item.id}
                                        date={formatOpenTimeLabel(item.date_initial)}
                                        status={item.formatedStatus}
                                        requester={item.requester}
                                        problem={item.problem}
                                        observation={item.observation}
                                        labelId="Chamado Nº"
                                    />

                                </React.Fragment>
                            ))}
                        </ReportSection>
                    ) : (
                        <ReportSection title="Infraestrutura (Chamados)" project={project} period={period}>
                            <div className="block relative break-inside-auto text-[15px] italic text-gray-500 py-4">Sem chamados durante o período.</div>
                            <div className={`w-full h-[0.2px] rounded-full bg-[#686868] my-1`}></div>
                        </ReportSection>
                    )}
            </div>

            <div className="w-full h-[297mm] break-before-page break-inside-avoid relative z-50 bg-white print:color-adjust-exact">

                <img
                    className="absolute inset-0 w-full h-full object-cover z-0"
                    src={`${BASENAME}/img/report_last_page.svg`}
                    alt="Última Página"
                />

                <div className="relative z-10 w-full h-full">

                    <a
                        href="https://web.facebook.com/sentrysistemas"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="absolute top-[91%] left-[7%] w-[19%] h-[3%] bg-transparent cursor-pointer block"
                    >
                    </a>

                    <a
                        href="https://www.instagram.com/sentry.sistema/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="absolute top-[91%] left-[27%] w-[18%] h-[3%] bg-transparent cursor-pointer block"
                    >
                    </a>

                    <a
                        href="https://www.linkedin.com/company/sentrysistemas"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="absolute top-[91%] left-[46%] w-[19%] h-[3%] bg-transparent cursor-pointer block"
                    >
                    </a>

                    <a
                        href="https://www.youtube.com/@sentrymuralhadigital"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="absolute top-[91%] left-[66%] w-[26%] h-[3%] bg-transparent cursor-pointer block"
                    >
                    </a>

                </div>

            </div>
        </div>
    );
};

export default PrintServiceProvided;
